/** The words of a search box value; commas separate words like spaces do. */
export function searchWords(query: string, minLength: number): string[] {
  return query
    .trim()
    .split(/[\s,]+/)
    .filter((word) => word.length >= minLength)
}

/**
 * An or=(...) filter matching the word anywhere in any of the columns. The
 * pattern is quoted because commas, dots, colons and parentheses would
 * otherwise end the value inside the logic tree.
 */
export function ilikeAnyColumn(columns: string[], word: string): string {
  const pattern = `"%${word.replace(/["\\]/g, '\\$&')}%"`
  return columns.map((column) => `${column}.ilike.${pattern}`).join(',')
}
